<div class="title" *ngIf="this.title">{{ title }}</div>
<p class="subtitle" *ngIf="this.subtitle">{{ this.subtitle }}</p>

<form [formGroup]="formGroup">
  <div class="mat-form-field-wrapper">
    <div
      [ngClass]="
        withHorizontalCheckbox || anyToShowDefined() || nullable ? 'd-flex' : ''
      "
      class="radio-group"
    >
      <mat-radio-group
        [formControlName]="'answer'"
        [ngClass]="flexRow ? 'row' : 'column'"
      >
        <ng-container *ngIf="yesFirst">
          <mat-radio-button
            [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
            [checked]="value"
            [disabled]="disabledYes"
            matTooltip="{{ tooltipYes }}"
            [matTooltipDisabled]="!disabledYes"
            (change)="answered(yesValue)"
            value="{{ true }}"
          >
            {{ yesValue }}
          </mat-radio-button>
          <mat-radio-button
            [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
            [checked]="!value && (nullIsFalse || value != null)"
            (change)="answered(noValue)"
            value="{{ false }}"
            [disabled]="disabledNo"
            matTooltip="{{ tooltipNo }}"
            [matTooltipDisabled]="!disabledNo"
          >
            {{ noValue }}
          </mat-radio-button>
        </ng-container>
        <ng-container *ngIf="!yesFirst">
          <mat-radio-button
            [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
            [checked]="!value && (nullIsFalse || value != null)"
            (change)="answered(noValue)"
            value="{{ false }}"
            [disabled]="disabledNo"
            matTooltip="{{ tooltipNo }}"
            [matTooltipDisabled]="!disabledNo"
          >
            {{ noValue }}
          </mat-radio-button>
          <mat-radio-button
            [ngClass]="flexRow ? 'y-n-button' : 'y-n-button flexer'"
            [checked]="value"
            [disabled]="disabledYes"
            matTooltip="{{ tooltipYes }}"
            [matTooltipDisabled]="!disabledYes"
            (change)="answered(yesValue)"
            value="{{ true }}"
          >
            {{ yesValue }}
          </mat-radio-button>
        </ng-container>
      </mat-radio-group>

      <div
        *ngIf="(value === true || value === false) && nullable"
        class="d-flex click-link italics-text align-reset"
        (click)="resetValue()"
      >
        <mat-icon svgIcon="close" class="small-icon"></mat-icon>
        <p class="flexer click-link italics-text align-with-icon">reset</p>
      </div>

      <div
        *ngIf="withHorizontalCheckbox"
        class="flexer align-horizontal-checkbox"
      >
        <checkbox
          [text]="horizontalCheckboxLabel"
          [checked]="horizontalCheckboxBoolean"
          (answer)="this.answeredHorizontalCheckbox($event)"
        ></checkbox>
      </div>

      <div *ngIf="value && anyToShowDefined()" class="flexer align-to-show">
        <div class="d-flex">
          —
          <p
            *ngIf="toShowDate != null || toShowASAP"
            class="to-show-space-left"
          >
            {{ toShowDateLabel }}:
            {{
              toShowDate != null
                ? printToShowDate()
                : toShowASAP
                ? 'ASAP'
                : 'Niet gekend'
            }}{{ showCommaAfterDate() ? ',&nbsp;' : '' }}
          </p>
          <div *ngIf="toShowEmployee != null" class="to-show-space-left d-flex">
            Medewerker:
          </div>
          <div
            *ngIf="toShowEmployee != null"
            class="employee-initials rounded-circle in-the-middle align-employee-circle"
            [matTooltip]="getEmployeeName(toShowEmployee)"
          >
            <span *ngIf="!toShowEmployee.user?.profilePicture">
              {{ getEmployeeLetters(toShowEmployee) }}
            </span>
            <span *ngIf="toShowEmployee.user?.profilePicture">
              <img
                class="rounded-circle"
                width="30px"
                height="30px"
                [src]="
                  '/api/assets/' +
                  toShowEmployee.user?.profilePicture?.uuid +
                  '/30'
                "
              />
            </span>
          </div>
          <p
            *ngIf="showBoolean"
            [ngClass]="toShowEmployee != null ? 'space-after-circle' : ''"
          >
            {{ toShowEmployee != null ? ', ' : '' }}Afgewerkt:
            {{ toShowBoolean ? 'Ja' : 'Nee' }}
          </p>
        </div>
      </div>

      <checkbox
        class="check"
        *ngIf="done != null && value"
        [text]="'klaar'"
        [checked]="done"
        (answer)="this.answeredDone($event)"
      >
      </checkbox>
    </div>

    <div
      *ngIf="
        (value === showInstructionOn || alwaysShowExtraInstructions) &&
        !neverShowExtraInstructions
      "
      [ngClass]="extraInstructionsTitle?.length > 0 ? 'upper-space' : ''"
    >
      <textarea-input
        [title]="extraInstructionsTitle"
        [placeholder]="extraInstructions"
        [initContent]="inputText"
        [answerChange]="answeredTextChange"
        [disabled]="disabled"
        [client]="client"
        [sensitive]="sensitiveText"
        (answer)="this.answeredYes($event)"
      ></textarea-input>
    </div>
  </div>
</form>
